import { getAccessToken } from '@app/utils/accessTokenStorage';

export const hasToken = () => getAccessToken() !== null;
